import type { ChannelTone } from "@/types/content";

export const toneSoft: Record<ChannelTone, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export const toneSolid: Record<ChannelTone, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-accent-950",
  secondary: "bg-secondary-500 text-background-50",
};

export const toneText: Record<ChannelTone, string> = {
  primary: "text-primary-700",
  accent: "text-accent-700",
  secondary: "text-secondary-700",
};

export const toneBorder: Record<ChannelTone, string> = {
  primary: "border-primary-200",
  accent: "border-accent-200",
  secondary: "border-secondary-200",
};

export const formatDate = (value: string): string => {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
};

export const formatViews = (value: number): string => {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return `${value}`;
};